import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import { SEARCH_INDEX_DELAY } from '../../consts';
import { DELETE_RESOURCE_MUTATION } from '../../../gql/mutations/RESOURCE_MUTATION';
  
const useDeleteResource = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( DELETE_RESOURCE_MUTATION );

    const handleDelete = async ( id, onFinishCallback ) => {
        setIsDeleting( true );

        try {  
            await deleteMutation( { variables: { input: { resourceId: id } } } );

            setTimeout( () => {
                if ( onFinishCallback ) { onFinishCallback(); }
                setIsDeleting( false );
            }, SEARCH_INDEX_DELAY );
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting resource!' );
            setIsDeleting( false );
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteResource: handleDelete
        };
    }, [ isDeleting ] );
};

export default useDeleteResource;
